// extracted by mini-css-extract-plugin
module.exports = {"inherit":"Icon-module--inherit--1IhZ0"};